"use strict";

exports.__esModule = true;
exports["default"] = createRequest;
exports.retry = exports.timeoutPromise = void 0;

var _lodash = require("lodash");

var _uri = require("./uri");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_TIMEOUT = 12000;
var RETRY_TIMEOUT = 2500;

function createRequest(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$apiBaseUrl = _ref.apiBaseUrl,
      apiBaseUrl = _ref$apiBaseUrl === void 0 ? '' : _ref$apiBaseUrl,
      _ref$instance = _ref.instance,
      instance = _ref$instance === void 0 ? '' : _ref$instance,
      instanceId = _ref.instanceId,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en' : _ref$locale,
      cookie = _ref.cookie,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? DEFAULT_TIMEOUT : _ref$timeout,
      _ref$performanceTrack = _ref.performanceTracker,
      performanceTracker = _ref$performanceTrack === void 0 ? {
    trackStart: _lodash.noop,
    trackEnd: _lodash.noop,
    parseHeader: _lodash.noop
  } : _ref$performanceTrack,
      _ref$fetchFunction = _ref.fetchFunction,
      fetchFunction = _ref$fetchFunction === void 0 ? undefined : _ref$fetchFunction,
      _ref$additionalHeader = _ref.additionalHeaders,
      additionalHeaders = _ref$additionalHeader === void 0 ? {} : _ref$additionalHeader;

  var request = function request(path, config) {
    if (config === void 0) {
      config = {};
    }

    var url = (0, _uri.normalizeUrl)("" + (0, _lodash.trimEnd)(config.apiBaseUrl || apiBaseUrl, '/') + path);
    var shouldParseHeaders = config.parseHeaders;
    var retryCount = config.retry;
    delete config.retry;
    delete config.parseHeaders;
    var headers = (0, _lodash.pickBy)(_objectSpread(_objectSpread({}, config.headers), {}, {
      instance: instance,
      instanceId: instanceId,
      Authorization: instance,
      locale: locale,
      cookie: cookie
    }, additionalHeaders));
    (0, _lodash.extend)(config, {
      headers: headers,
      timeout: timeout,
      credentials: (0, _lodash.get)(config, 'credentials', 'same-origin')
    }, request.meteredPathKey ? {
      meteredPathKey: request.meteredPathKey
    } : {});
    var marker = performanceTracker.trackStart((config.method || 'GET') + " " + path + " " + Date.now() % 10000);

    var start = function start() {
      return fetchFunction ? fetchFunction(url, config) : fetch(url, config);
    };

    var parse = function parse(res) {
      return Promise.resolve(res).then(handleSuccess).then(function (response) {
        performanceTracker.trackEnd(marker, performanceTracker.parseHeader(response));
        return response;
      }).then(shouldParseHeaders ? parseHeadersAndBody : parseBody);
    };

    return retry(start, url, retryCount, timeout).then(parse);
  };

  request.post = function (path, data, config) {
    return request(path, (0, _lodash.merge)({}, config, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }));
  };

  request.put = function (path, data, config) {
    return request(path, (0, _lodash.merge)({}, config, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }));
  };

  request.patch = function (path, data, config) {
    return request(path, (0, _lodash.merge)({}, config, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }));
  };

  request["delete"] = function (path, config) {
    return request(path, (0, _lodash.extend)({}, config, {
      method: 'DELETE'
    }));
  };

  request.uploadFile = function (file, credentials) {
    var formData = new FormData();
    formData.append('file', file);
    formData.append('media_type', 'picture');
    formData.append('upload_token', credentials.uploadToken);
    formData.append('parent_folder_id', credentials.folderId);
    var config = {
      method: 'POST',
      body: formData
    };
    return fetch(credentials.uploadUrl, config).then(handleSuccess).then(parseBody);
  };

  request.metered = function (meteredPathKey) {
    return Object.assign(request, {
      meteredPathKey: meteredPathKey
    });
  };

  return request;
}

function handleSuccess(response) {
  var status = response.status;

  if (status < 400) {
    return response;
  }

  return Promise.reject(response);
}

function parseBody(response) {
  return response.json()["catch"](function () {
    return Promise.resolve();
  });
}

function parseHeadersAndBody(response) {
  return response.json().then(function (data) {
    return {
      body: data,
      headers: response.headers
    };
  })["catch"](function () {
    return Promise.resolve();
  });
}

var timeoutPromise = function timeoutPromise(promise, ms, errMsg) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new Error(errMsg));
    }, ms);
    promise.then(resolve, reject);
  });
};

exports.timeoutPromise = timeoutPromise;

var retry = function retry(fn, url, retries, timeout) {
  if (retries === void 0) {
    retries = 1;
  }

  if (timeout === void 0) {
    timeout = RETRY_TIMEOUT;
  }

  return new Promise(function (resolve, reject) {
    return timeoutPromise(fn(), timeout, "Fetch timed out after " + timeout + "ms at url: " + url).then(function (response) {
      if (response.status >= 500 && retries > 0) {
        return retry(fn, url, retries - 1).then(resolve, reject);
      }

      resolve(response);
    }, function (error) {
      if (retries > 0) {
        return retry(fn, url, retries - 1).then(resolve, reject);
      }

      reject(error);
    });
  });
};

exports.retry = retry;